<div class="d-flex flex-wrap">
  <span>
    <span class="mr-1">{{ course.library }} {{ course.type }}: {{ course.credits }}</span>
    <span class="d-none d-md-inline mx-1 pl-2 tag" *ngFor="let tag of course.tags">{{ tag }}</span>
  </span>
  <a *ngIf="ucdService.IsLoggedIn" href="#" (click)="toggleFavorite()" class="ml-1">
    <fa-icon *ngIf="!course.userData.Favorite" [icon]="['far','bookmark']" class="fa-lg" title="Bookmark this course">
    </fa-icon>
    <fa-icon *ngIf="course.userData.Favorite" [icon]="['fas','bookmark']" class="fa-lg"
      title="Remove this course bookmark"></fa-icon>
  </a>
</div>